module.exports = __webpack_public_path__ + "img/9788959525638.96f9902f.jpg";